import { useIntRegov } from '@owlmeans/regov-lib-react';

export const useRegov = useIntRegov;
